exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-nellemann {\n    background-color: black;\n}\n\n.btn-nellemann:disabled {\n    opacity: 1;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/landingpages/dealerpage/dealerpage.component.css
// module id = 1018
// module chunks = 23